import { Translate, Spinner, Modal } from 'components';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { fromResource } from 'store/selectors';
import { fulfilled, pending } from 'redux-saga-thunk';
import {
  resourceCreateRequest,
  resourceDetailReadRequest,
} from 'store/actions';
import PropTypes from 'prop-types';
import { localDayjs } from 'utils/dateTimeUtils';

function Information({
  infoPages = [],
  isPending = false,
  isFullfilled = false,
  onReadInformationStatus = () => {},
  onGetInformationPage = () => {},
}) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [information, setInformation] = useState(null);

  const InfoImage = ({ imageBase64 = '' }) => {
    if (!imageBase64) return null;

    const src = `data:image/png;base64,${imageBase64}`;

    return <img className="tv-information-modal__image" src={src} alt="Info" />;
  };

  InfoImage.propTypes = {
    imageBase64: PropTypes.string,
  };

  const parsePublishDate = date =>
    localDayjs.tz(date, 'M/D/YYYY h:mm:ss A', 'Europe/Stockholm');

  const formatSwedishDate = date => {
    const formatted = parsePublishDate(date).locale('sv').format('dddd D MMMM YYYY');

    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  };

  const sortedInfoPages = [...infoPages].sort(
    (a, b) =>
      parsePublishDate(b.DatetimePublish).valueOf() -
      parsePublishDate(a.DatetimePublish).valueOf(),
  );

  useEffect(() => {
    if (isFullfilled) {
      onGetInformationPage();
    }
  }, [isFullfilled]);

  useEffect(() => {
    onGetInformationPage();
  }, []);

  return (
    <>
      <div className="tv-notification__page">
        <h2 className="tv-notification__page__title">Aktuellt</h2>
        <div className="tv-notification__container-fluid  ">
          <div>
            {infoPages.length === 0 && (
              <div className="tv-notification__no-item">
                Du har just nu inga nya aktuellt
              </div>
            )}
            {sortedInfoPages.map((item, index) => (
              <div
                className="tv-general-notification__container"
                role="button"
                onClick={() => {
                  setInformation(item);
                  setIsModalVisible(true);
                  if (!item.IsRead) {
                    onReadInformationStatus({
                      InformationPageIdentifier: item.InformationPageIdentifier,
                    });
                  }
                }}
                tabIndex={0}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    setInformation(item);
                    setIsModalVisible(true);
                    if (!item.IsRead) {
                      onReadInformationStatus({
                        InformationPageIdentifier:
                          item.InformationPageIdentifier,
                      });
                    }
                  }
                }}
                key={index}
              >
                <div className="tv-general-notification__wrapper tv-information__wrapper">
                  <div className="tv-general-notification__title">
                    {!item.IsRead && (
                      <div className="tv-general-notification__new-label tv-general-notification__new-label-forpage tv-information__new-label">
                        {Translate({ content: 'notification.new' })}
                      </div>
                    )}
                    {item.Title}
                  </div>
                  <div className="tv-information__date">
                    <i className="fa fa-clock" />
                    <span>{formatSwedishDate(item.DatetimePublish)}</span>
                  </div>
                </div>
                <div
                  className="tv-general-notification__message tv-general-notification__message-forpage"
                  dangerouslySetInnerHTML={{ __html: item.Introduction }}
                />
                <span className="tv-information__read-more">Läs mer</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {isModalVisible && (
        <Modal
          mainTitle={information ? information.Title : 'Detaljerad information'}
          isVisible={isModalVisible}
          className="tv-information-modal__container"
          onClose={() => {
            setIsModalVisible(false);
          }}
        >
          <div className="tv-information-modal__content">
            <div className="tv-information__date">
              <i className="fa fa-clock" />
              <span>{formatSwedishDate(information.DatetimePublish)}</span>
            </div>
            <p
              className="tv-information-modal__introduction"
              dangerouslySetInnerHTML={{ __html: information.Body }}
            />
            {InfoImage({ imageBase64: information.Image })}
          </div>
        </Modal>
      )}

      {isPending && <Spinner />}
    </>
  );
}

Information.propTypes = {
  infoPages: PropTypes.array,
  isPending: PropTypes.bool,
  isFullfilled: PropTypes.bool,
  onReadInformationStatus: PropTypes.func,
  onGetInformationPage: PropTypes.func,
};

const mapStateToProps = state => {
  const infoPages = fromResource.getDetail(state, 'getInformationPage') || [];
  const isPending =
    pending(state, 'getInformationPageDetailRead') ||
    pending(state, 'setInformationPageReadStatusCreate');
  const isFullfilled = fulfilled(state, 'setInformationPageReadStatusCreate');
  return {
    infoPages: infoPages.InformationPages || [],
    isPending,
    isFullfilled,
  };
};

const mapDispatchToProps = dispatch => ({
  onReadInformationStatus: data =>
    dispatch(resourceCreateRequest('setInformationPageReadStatus', data)),
  onGetInformationPage: () =>
    dispatch(resourceDetailReadRequest('getInformationPage')),
});
export default connect(mapStateToProps, mapDispatchToProps)(Information);
